import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CoreModule} from '../core.module';
import {SharedModule} from '../shared/shared.module';
import {OrganizationDetailComponent} from './organization-detail/organization-detail.component';
import {OrganizationModifyComponent} from './organization-modify/organization-modify.component';
import {OrganizationComponent} from './organization.component';
import {
  OrganizationDetailInformationComponent
} from './organization-modify/organization-detail-information/organization-detail-information.component';
import {OrganizationAppointeesComponent} from './organization-modify/organization-appointees/organization-appointees.component';
import {OrganizationInteractionsComponent} from './organization-modify/organization-interactions/organization-interactions.component';
import { OrganizationReportingComponent } from './organization-modify/organization-reporting/organization-reporting.component';
import { OrganizationConstitutionComponent } from './organization-modify/organization-constitution/organization-constitution.component';
import {
  OrganizationCustomWidgetsComponent
} from "./organization-modify/organization-custom-widgets/organization-custom-widgets-component";
import {DataPortalModule} from "../data-portal/data-portal.module";

@NgModule({
  imports: [
    CommonModule, CoreModule, SharedModule, DataPortalModule
  ],
  declarations: [
    OrganizationComponent,
    OrganizationDetailComponent,
    OrganizationModifyComponent,
    OrganizationDetailInformationComponent,
    OrganizationAppointeesComponent,
    OrganizationInteractionsComponent,
    OrganizationReportingComponent,
    OrganizationConstitutionComponent,
    OrganizationCustomWidgetsComponent
  ],
  exports: [
    OrganizationComponent
  ]
})
export class OrganizationModule {
}
